<script>
  import * as restfulService from '../../../services/restfulService'

  import {mapActions} from 'vuex'
  import bus from '@utils/bus'
  import helpers from '@mixins/helper'

  export default {
    mixins: [helpers],
    name: 'dashboard-graduacao-i-cpp-popup',
    data () {
      return {
        lista: [],
        cppSelecionado: '',
        mostrarModal: false
      }
    },
    mounted () {
      /*
      this.buscarPopup()
      */
    },
    computed: {
      isMobileSize: function () {
        return this.isMobile().any()
      }
    },
    methods: {
      ...mapActions(['showNotification']),
      buscarPopup () {
        restfulService.get('dashboard', 'popup-graduacao-i-cpp')
          .then(response => {
            if (response.length > 0) {
              this.lista = [...response]
              this.mostrarModal = true
            }
          })
          .catch(e => {
            console.log(e)
          })
      },
      salvarCpp () {
        bus.$emit('show-loader')
        const competencia = this.lista.find(item => item.nome === this.cppSelecionado)
        const data = {
          ref_disciplina_subst: competencia.id,
          nome_cpp: competencia.nome,
          ref_campus: competencia.ref_campus,
          ref_curriculo: competencia.ref_curriculo
        }
        restfulService.post('cpp', null, null, data)
          .then(() => {
            bus.$emit('hide-loader')
            this.mostrarModal = false
            this.showNotification({message: 'Sua escolha de competência foi registrada'})
          })
          .catch(e => {
            bus.$emit('hide-loader')
            this.mostrarModal = false
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <div>
        <v-dialog v-model="mostrarModal"
                  :width="isMobileSize ? '90%' : '40%'">
            <v-card class="popup-modal">
                <v-container>
                    <h3 class="pb-3" :class="{'display-0': isMobileSize, 'display-1': !isMobileSize}">Competências
                        Pessoais e Profissionais (CPP)</h3>
                    <div class="text">
                        <p :class="{'body-1': isMobileSize, 'subheading': !isMobileSize}">
                            A URCAMP dá início neste 1º semestre de 2019, ao novo modelo de ensino chamado GRADUAÇÃO I.
                            É um importante passo para a inovação no ensino superior, implantando o ensino por
                            competências, onde o aluno sai com uma experiência prática muito mais aprofundada, com
                            experiências que vão além da sala de aula.
                            Nesta modalidade todas as noites têm aulas presenciais, sendo que nas noites de sexta-feira
                            será ministrada a CPP (Competência Pessoal e Profissional), as CPP's são temas inerentes ao
                            ensino superior, que serão oferecidos para todos os cursos.
                        </p>
                        <v-radio-group v-model="cppSelecionado" class="cpp-lista">
                            <v-radio v-for="(item, index) in lista"
                                     :key="index"
                                     :label="`${item.nome} / Vagas: ${item.vagas}`"
                                     color="primary"
                                     :value="item.nome">
                            </v-radio>
                        </v-radio-group>
                    </div>
                    <div style="text-align: center;">
                        <v-btn color="success"
                               block
                               large
                               :disabled="!cppSelecionado"
                               @click="salvarCpp">Confirmar Selecão
                        </v-btn>
                    </div>
                </v-container>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @click="mostrarModal = false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<style lang="scss">
    .cpp-lista {
        .v-radio {
            padding: 0 8px;

            &.primary--text {
                padding: 8px;
                border: 1px solid #DDD;
                background-color: #f2f2f2;
            }
        }
    }

    @media all and (max-width: 768px) {
        .cpp-lista {
            .v-radio {
                label {
                    font-size: 14px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// GraduacaoICppPopup.vue?2991730c